var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Col',{attrs:{"span":_vm.config.span || 24}},[(_vm.isShow)?_c('tinymce-editor',{attrs:{"height":_vm.config.height,"placeholder":_vm.config.placeholder},model:{value:(_vm.data[_vm.config.key]),callback:function ($$v) {_vm.$set(_vm.data, _vm.config.key, $$v)},expression:"data[config.key]"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }